export const space = {
  xxs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '48px',
  xxxl: '64px',
}

export const breakpoints = {
  mobile: '@media(min-width: 550px)',
  tablet: '@media(min-width: 720px)',
  desktop: '@media(min-width: 1000px)',
  desktopLarge: '@media(min-width: 1367px)',
}

export const fonts = {
  primary:
    "'FrogSerif', 'Times New Roman', Times, serif",
  secondary:
    "'GTAmericaRegular', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif",
  tertiary:
    "'GTAmericaRegular', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif",
  flair:
    "'FrogSerif', 'Times New Roman', Times, serif",
}

export const colors = {
  blue: '#002ACC',
  lightGray: '#F3F4F9',
  midGray: '#E6EAEA',
  gray: '#999999',
  black: '#000000',
  white: '#FFFFFF',
  blueDark: '#000C39',
  whiteLight: 'rgb(255, 255, 255, 0.7)',
  red: '#ff5b5d',
}

export const theme = {
  space,
  breakpoints,
  fonts,
  colors,
}

export default theme

export const CONTENT_MARGIN_Y = 16
export const CONTENT_MARGIN_Y_DESKTOPUP = 32
export const CONTENT_MARGIN_X = 24
export const HEADER_HEIGHT = 32
export const CONTENT_MAX_WIDTH = 1440
export const CARD_MAX_WIDTH = 480
